// Importar estilos primeiro (Vite processa em build time)
import './styles/global.css';
import './styles/button.component.css';
import './styles/campaigns.css';
import './styles/campaign-detail.css';
import './styles/challenge.css';
import './styles/toolbar.css';
import './styles/splash-screen.css';
import './styles/reward.css';
import './styles/how-it-works.css';
import './styles/carrot-redirect.css';
import 'float-label-css/dist/float-label.min.css';

// Bootstrap da aplicação
import { bootstrap } from './app/bootstrap';
import { logger } from './utils/logger.util';

// Inicializar aplicação
bootstrap().catch((error) => {
  logger.error('Erro fatal ao inicializar aplicação:', error);
});

